import { createSlice } from '@reduxjs/toolkit';
import {
  sendForgetPasswordEmail,
  verifyResetCode,
  resendForgetCode,
  resetPassword,
} from '../actions/forgetPasswordAction';

const initialState = {
  isLoading: false,
  success: false,
  error: null,
  data: null,
  codeVerified: false,
  resendLoading: false,
  resendSuccess: false,
};

const forgetPasswordSlice = createSlice({
  name: 'forgetPassword',
  initialState,
  reducers: {
    resetForgetPasswordState: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error = null;
      state.data = null;
      state.resendLoading = false;
      state.resendSuccess = false;
    },
    resetCodeVerified: (state) => {
      state.codeVerified = false;
    },
  },
  extraReducers: (builder) => {
    // Send forget password email
    builder.addCase(sendForgetPasswordEmail.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(sendForgetPasswordEmail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(sendForgetPasswordEmail.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // Verify reset code
    builder.addCase(verifyResetCode.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
      state.codeVerified = false;
    });
    builder.addCase(verifyResetCode.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.data = action.payload;
      state.codeVerified = true;
    });
    builder.addCase(verifyResetCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.codeVerified = false;
    });

    // Resend forget code
    builder.addCase(resendForgetCode.pending, (state) => {
      state.resendLoading = true;
      state.resendSuccess = false;
      state.error = null;
    });
    builder.addCase(resendForgetCode.fulfilled, (state, action) => {
      state.resendLoading = false;
      state.resendSuccess = true;
      state.data = action.payload;
    });
    builder.addCase(resendForgetCode.rejected, (state, action) => {
      state.resendLoading = false;
      state.error = action.payload;
    });

    // Reset password
    builder.addCase(resetPassword.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetForgetPasswordState, resetCodeVerified } = forgetPasswordSlice.actions;
export default forgetPasswordSlice.reducer;
